import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Por defecto caer a español si no hay preferencia explícita
    fallbackLng: 'es',
    supportedLngs: ['en', 'es', 'zh', 'hi', 'fr', 'ar', 'bn', 'pt', 'ru', 'de'],
    nonExplicitSupportedLngs: true, // Permite mapear es-AR -> es, pt-BR -> pt, etc.
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      // Evitar cacheo del navegador cuando actualizamos textos
      queryStringParams: { v: String(Date.now()) }
    },
    detection: {
      // Leer primero de almacenamiento/localStorage o cookie para respetar elección del usuario
      order: ['querystring', 'localStorage', 'cookie', 'path', 'subdomain', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      checkWhitelist: true,
      caches: ['localStorage', 'cookie'],
    }
  });

export default i18n; 